import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface CompanyState {
  // State
  selectedCompanyId: number | null;
  /** When false, selectedCompanyId is not persisted - user sees company selection on every visit */
  rememberSelection: boolean;

  // Actions
  selectCompany: (companyId: number | null) => void;
  setRememberSelection: (value: boolean) => void;
  clearCompany: () => void;
}

/**
 * Zustand store for company selection
 * Persists to localStorage. When rememberSelection is false, selectedCompanyId is cleared on rehydration.
 */
export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      // Initial state
      selectedCompanyId: null,
      rememberSelection: true,

      // Actions
      selectCompany: (companyId) =>
        set({ selectedCompanyId: companyId }),

      setRememberSelection: (value) =>
        set({ rememberSelection: value }),

      clearCompany: () =>
        set({ selectedCompanyId: null }),
    }),
    {
      name: 'company-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        // When rememberSelection is false, clear persisted selectedCompanyId so user sees selection page
        if (state?.rememberSelection === false && state?.selectedCompanyId) {
          useCompanyStore.setState({ selectedCompanyId: null });
        }
      },
    }
  )
);

